import React from 'react';
import { Link } from 'react-router-dom';
import './SaveTheDate.css';

const SaveTheDate: React.FC = () => {
  return (
    <div className="save-the-date-container">
      <div className="decorative-corner top-left"></div>
      <div className="decorative-corner top-right"></div>
      <div className="decorative-corner bottom-left"></div>
      <div className="decorative-corner bottom-right"></div>
      
      <div className="save-the-date-content">
        <div className="date-card">
          <div className="ornamental-line"></div>
          
          <h1 className="save-title">Enregistrez la date</h1>
          
          <div className="date-display">
            <div className="date-day">3</div>
            <div className="date-month">Octobre 2026</div>
          </div>

          <div className="hearts-divider">
            <span className="heart">♥</span>
            <span className="heart-dot">•</span>
            <span className="heart">♥</span>
            <span className="heart-dot">•</span>
            <span className="heart">♥</span>
          </div>
          
          <p className="save-message">
            Nous sommes ravis de vous inviter à célébrer notre mariage
          </p>

          <div className="venue-info">
            <div className="venue-name">Cabane à sucre chez Ti-Père</div>
            <div className="venue-address">4335 route Caya, Drummondville</div>
            <div className="venue-postal">J2A 2Z8</div>
          </div>
          
          <p className="save-tagline">
            Plus de détails à venir
          </p>
          
          <div className="ornamental-line"></div>
          
          {/* <div className="login-prompt">
            <p className="prompt-text">Déjà invité ?</p>
            <Link to="/login" className="login-button">
              Accéder à votre invitation
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SaveTheDate;
